export default {
  "add-extension": () => import("./add_extension_controller.js"),
  "add-to-project": () => import("./add_to_project_controller.js"),
  "admin--activity-report-link": () => import("./admin/activity_report_link_controller.js"),
  "admin--dynamic-list": () => import("./admin/dynamic_list_controller.js"),
  "admin--global-search": () => import("./admin/global_search_controller.js"),
  "admin--organization-timeline": () => import("./admin/organization_timeline_controller.js"),
  "admin--quiz-builder": () => import("./admin/quiz_builder_controller.js"),
  "admin--select": () => import("./admin/select_controller.js"),
  "admin--similar-entities": () => import("./admin/similar_entities_controller.js"),
  "admin--sortable-pills": () => import("./admin/sortable_pills_controller.js"),
  "admin--table": () => import("./admin/table_controller.js"),
  "all-or-none": () => import("./all_or_none_controller.js"),
  "assistant-feedback": () => import("./assistant_feedback_controller.js"),
  "assistant-pill-conversation": () => import("./assistant_pill_conversation_controller.js"),
  "assistant-sidebar-sandbox": () => import("./assistant_sidebar_sandbox_controller.js"),
  "assistant-suggestions-rail": () => import("./assistant_suggestions_rail_controller.js"),
  "autohide": () => import("./autohide_controller.js"),
  "automation-schedule": () => import("./automation_schedule_controller.js"),
  "automation-schedule-prompt": () => import("./automation_schedule_prompt_controller.js"),
  "autonumeric": () => import("./autonumeric_controller.js"),
  "back-button-fix": () => import("./back_button_fix_controller.js"),
  "bulk-table": () => import("./bulk_table_controller.js"),
  "bulk-tags": () => import("./bulk_tags_controller.js"),
  "cert-verification": () => import("./cert_verification_controller.js"),
  "check-form-data": () => import("./check_form_data_controller.js"),
  "checkbox-alterer": () => import("./checkbox_alterer_controller.js"),
  "checkbox-setter": () => import("./checkbox_setter_controller.js"),
  "chronogram": () => import("./chronogram_controller.js"),
  "close-on-outside-click": () => import("./close_on_outside_click_controller.js"),
  "cnis-form": () => import("./cnis_form_controller.js"),
  "codemirror": () => import("./codemirror_controller.js"),
  "collapsed-attention": () => import("./collapsed_attention_controller.js"),
  "color-palette": () => import("./color_palette_controller.js"),
  "control-input-select": () => import("./control_input_select_controller.js"),
  "control-summary": () => import("./control_summary_controller.js"),
  "course-completion-delay": () => import("./course_completion_delay_controller.js"),
  "course-navigation": () => import("./course_navigation_controller.js"),
  "cpvs": () => import("./cpvs_controller.js"),
  "crisp-launcher": () => import("./crisp_launcher_controller.js"),
  "date-picker": () => import("./date_picker_controller.js"),
  "date-sort": () => import("./date_sort_controller.js"),
  "demo-sector": () => import("./demo_sector_controller.js"),
  "demo-slide-deck": () => import("./demo_slide_deck_controller.js"),
  "dependent-field": () => import("./dependent_field_controller.js"),
  "details": () => import("./details_controller.js"),
  "details-url-hash": () => import("./details_url_hash_controller.js"),
  "discard-reason": () => import("./discard_reason_controller.js"),
  "discardable-items": () => import("./discardable_items_controller.js"),
  "dismissable": () => import("./dismissable_controller.js"),
  "document-status-update": () => import("./document_status_update_controller.js"),
  "documents": () => import("./documents_controller.jsx"),
  "dropdown-flip": () => import("./dropdown_flip_controller.js"),
  "droppable": () => import("./droppable_controller.js"),
  "duration-adder": () => import("./duration_adder_controller.js"),
  "editor": () => import("./editor_controller.js"),
  "editor-download": () => import("./editor_download_controller.js"),
  "editor-presence": () => import("./editor_presence_controller.js"),
  "elapsed-timer": () => import("./elapsed_timer_controller.js"),
  "email-notification-toggle": () => import("./email_notification_toggle_controller.js"),
  "email-validator": () => import("./email_validator_controller.js"),
  "embeds--assistant-submit": () => import("./embeds/assistant_submit_controller.js"),
  "estimate-form": () => import("./estimate_form_controller.js"),
  "events": () => import("./events_controller.js"),
  "external-sorting-spinner": () => import("./external_sorting_spinner_controller.js"),
  "filter-input": () => import("./filter_input_controller.js"),
  "floating-assistant": () => import("./floating_assistant_controller.js"),
  "floating-widget-discover": () => import("./floating_widget_discover_controller.js"),
  "floating-widget-help-conditional": () => import("./floating_widget_help_conditional_controller.js"),
  "floating-widget-help": () => import("./floating_widget_help_controller.js"),
  "floating-widget-novedades": () => import("./floating_widget_novedades_controller.js"),
  "focus-comment-form": () => import("./focus_comment_form_controller.js"),
  "focus": () => import("./focus_controller.js"),
  "form": () => import("./form_controller.js"),
  "form-prefill": () => import("./form_prefill_controller.js"),
  "fullscreen": () => import("./fullscreen_controller.js"),
  "guide-links": () => import("./guide_links_controller.js"),
  "guide-sidebar": () => import("./guide_sidebar_controller.js"),
  "heading-permalink": () => import("./heading_permalink_controller.js"),
  "highlight-target": () => import("./highlight_target_controller.js"),
  "hover-popover": () => import("./hover_popover_controller.js"),
  "image-gallery": () => import("./image_gallery_controller.js"),
  "import-checkbox-manager": () => import("./import_checkbox_manager_controller.js"),
  "inline-edit-submitter": () => import("./inline_edit_submitter_controller.js"),
  "internal-contract-extensions-manager": () => import("./internal_contract_extensions_manager_controller.js"),
  "internal-contracts-validations": () => import("./internal_contracts_validations_controller.js"),
  "invoicing-milestones": () => import("./invoicing_milestones_controller.js"),
  "kanban-card-removal": () => import("./kanban_card_removal_controller.js"),
  "kanban": () => import("./kanban_controller.js"),
  "kanban-filters": () => import("./kanban_filters_controller.js"),
  "knowledge-autolink": () => import("./knowledge_autolink_controller.js"),
  "knowledge-editor": () => import("./knowledge_editor_controller.js"),
  "knowledge-lead-gate": () => import("./knowledge_lead_gate_controller.js"),
  "layout": () => import("./layout_controller.js"),
  "lazy-load-ivoox": () => import("./lazy_load_ivoox_controller.js"),
  "lazy-load-youtube": () => import("./lazy_load_youtube_controller.js"),
  "lead-capture": () => import("./lead_capture_controller.js"),
  "lead-modal": () => import("./lead_modal_controller.js"),
  "legislation--article-graph": () => import("./legislation/article_graph_controller.js"),
  "legislation--ask-assistant": () => import("./legislation/ask_assistant_controller.js"),
  "legislation--law-graph": () => import("./legislation/law_graph_controller.js"),
  "legislation--law-search": () => import("./legislation/law_search_controller.js"),
  "legislation--law-sidebar": () => import("./legislation/law_sidebar_controller.js"),
  "legislation--legislation-search": () => import("./legislation/legislation_search_controller.js"),
  "loading": () => import("./loading_controller.js"),
  "local-select": () => import("./local_select_controller.js"),
  "local-select-with-creation": () => import("./local_select_with_creation_controller.js"),
  "mailerlite-webform": () => import("./mailerlite_webform_controller.js"),
  "mark-active": () => import("./mark_active_controller.js"),
  "markdown-preview": () => import("./markdown_preview_controller.js"),
  "markdown-utils": () => import("./markdown_utils_controller.js"),
  "mentionable": () => import("./mentionable_controller.js"),
  "modal": () => import("./modal_controller.js"),
  "modal-opener": () => import("./modal_opener_controller.js"),
  "nested-form": () => import("./nested_form_controller.js"),
  "password-strength": () => import("./password_strength_controller.js"),
  "persistent-dismissable": () => import("./persistent_dismissable_controller.js"),
  "popover-anchor": () => import("./popover_anchor_controller.js"),
  "popover-dismiss": () => import("./popover_dismiss_controller.js"),
  "print": () => import("./print_controller.js"),
  "print-layout-image-swap": () => import("./print_layout_image_swap_controller.js"),
  "print-layout-preview": () => import("./print_layout_preview_controller.js"),
  "print-layout-variable-inserter": () => import("./print_layout_variable_inserter_controller.js"),
  "project-annualities": () => import("./project_annualities_controller.js"),
  "project-batches": () => import("./project_batches_controller.js"),
  "project-tax-calculation": () => import("./project_tax_calculation_controller.js"),
  "projects--contracting-systems": () => import("./projects/contracting_systems_controller.js"),
  "question-select": () => import("./question_select_controller.js"),
  "quiz": () => import("./quiz_controller.js"),
  "read-more": () => import("./read_more_controller.js"),
  "redactor-node": () => import("./redactor_node_controller.js"),
  "redactor-node-sandbox": () => import("./redactor_node_sandbox_controller.js"),
  "refresh-form": () => import("./refresh_form_controller.js"),
  "registrations--form": () => import("./registrations/form_controller.js"),
  "remote-select": () => import("./remote_select_controller.js"),
  "report-subject-search": () => import("./report_subject_search_controller.js"),
  "review-sync": () => import("./review_sync_controller.js"),
  "rotating-text": () => import("./rotating_text_controller.js"),
  "sales-leads-engagement": () => import("./sales_leads_engagement_controller.js"),
  "search-results": () => import("./search_results_controller.js"),
  "search-title-mirror": () => import("./search_title_mirror_controller.js"),
  "select-all": () => import("./select_all_controller.js"),
  "select-alterer": () => import("./select_alterer_controller.js"),
  "select-count-alterer": () => import("./select_count_alterer_controller.js"),
  "select-duo": () => import("./select_duo_controller.js"),
  "select-with-no-value": () => import("./select_with_no_value_controller.js"),
  "shortcut-submitable-form": () => import("./shortcut_submitable_form_controller.js"),
  "sidebar-terms": () => import("./sidebar_terms_controller.js"),
  "similar-questions": () => import("./similar_questions_controller.js"),
  "sortable": () => import("./sortable_controller.js"),
  "sortable-table": () => import("./sortable_table_controller.js"),
  "spinner": () => import("./spinner_controller.js"),
  "sticky-nav": () => import("./sticky_nav_controller.js"),
  "sticky-offset": () => import("./sticky_offset_controller.js"),
  "submit-on-blur": () => import("./submit_on_blur_controller.js"),
  "submit-on-change": () => import("./submit_on_change_controller.js"),
  "submit-overlay": () => import("./submit_overlay_controller.js"),
  "suggestion-impression": () => import("./suggestion_impression_controller.js"),
  "suggestions-list": () => import("./suggestions_list_controller.js"),
  "system-messages": () => import("./system_messages_controller.js"),
  "table-header-sort": () => import("./table_header_sort_controller.js"),
  "table-inline-update": () => import("./table_inline_update_controller.js"),
  "table-manager": () => import("./table_manager_controller.js"),
  "table-resize": () => import("./table_resize_controller.js"),
  "tags": () => import("./tags_controller.js"),
  "task-due-date": () => import("./task_due_date_controller.js"),
  "task-map": () => import("./task_map_controller.js"),
  "task-phase": () => import("./task_phase_controller.js"),
  "task-templates": () => import("./task_templates_controller.js"),
  "tasks-new-collection": () => import("./tasks_new_collection_controller.js"),
  "template-selector": () => import("./template_selector_controller.js"),
  "templates--form-handler": () => import("./templates/form_handler_controller.js"),
  "templates--importer": () => import("./templates/importer_controller.js"),
  "templates--tiptap-preview": () => import("./templates/tiptap_preview_controller.js"),
  "templates--variable-inserter": () => import("./templates/variable_inserter_controller.js"),
  "tender-layout-toggle": () => import("./tender_layout_toggle_controller.js"),
  "time-ago": () => import("./time_ago_controller.js"),
  "tippy": () => import("./tippy_controller.js"),
  "toc": () => import("./toc_controller.js"),
  "tool-call-toggle": () => import("./tool_call_toggle_controller.js"),
  "update-history": () => import("./update_history_controller.js"),
  "upload-document": () => import("./upload_document_controller.js"),
  "url-refresher": () => import("./url_refresher_controller.js"),
  "user-picker": () => import("./user_picker_controller.js"),
  "visible-columns": () => import("./visible_columns_controller.js"),
  "visualizations--commons": () => import("./visualizations/commons_controller.js"),
  "visualizations--distribution": () => import("./visualizations/distribution_controller.js"),
  "visualizations--evolution": () => import("./visualizations/evolution_controller.js"),
  "visualizations--fetch": () => import("./visualizations/fetch_controller.js"),
  "visualizations": () => import("./visualizations_controller.js"),
  "voice-dictation": () => import("./voice_dictation_controller.js"),
  "voice-dictation-sandbox": () => import("./voice_dictation_sandbox_controller.js"),
  "webinar-cancellation": () => import("./webinar_cancellation_controller.js"),
  "webinar-card-badge": () => import("./webinar_card_badge_controller.js"),
  "webinar-registration": () => import("./webinar_registration_controller.js"),
  "writer-document-new-thread": () => import("./writer_document_new_thread_controller.js"),
  "writer-document-thread": () => import("./writer_document_thread_controller.js"),
  "writer-document-thread-filters": () => import("./writer_document_thread_filters_controller.js"),
  "writer-proposal": () => import("./writer_proposal_controller.js"),
  "writer-reviewer-form": () => import("./writer_reviewer_form_controller.js"),
  "writer-sidebar-tabs": () => import("./writer_sidebar_tabs_controller.js"),
  "writer-suggestion-thread": () => import("./writer_suggestion_thread_controller.js"),
  "writer-thread-card": () => import("./writer_thread_card_controller.js")
}
